<template>
  <div class="home" id="home">
    <NavMenu></NavMenu>
    <HomeMain></HomeMain>
    <HomeSellingPoint></HomeSellingPoint>
    <HomeIAA></HomeIAA>
    <HomeKnowMore></HomeKnowMore>
    <Footer></Footer>
  </div>
</template>

<script>
import NavMenu from "../../components/navMenu";
import HomeMain from "../../components/homeMain";
import HomeSellingPoint from "../../components/homeSellingPoint";
import HomeIAA from "../../components/homeIAA";
import HomeKnowMore from "../../components/homeKnowMore";

export default {
  name: "home",
  components: { NavMenu, HomeMain, HomeSellingPoint, HomeIAA, HomeKnowMore },
  data() {
    return {
      themeType: "dark",
      scroll: "",
      // headerTheme: 'light',

    };
  },
  mounted() {
    document.addEventListener("scroll", this.scrollListenFun, true);
  },
  methods: {
    scrollListenFun() {
      this.scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (this.scroll > 0) {
        this.themeType = "light";
      } else {
        this.themeType = "dark";
      }
    },
  },
};
</script>
